module.exports = __webpack_public_path__ + "img/c00_buildingtechpurebred_Normal_ua.40ea3753.webp";